import { InjectionToken } from '@angular/core';

// Injection token for configuring the Pricing API base URL via Angular providers
export const PRICING_API_BASE_URL = new InjectionToken<string>('PRICING_API_BASE_URL');